module.exports = __webpack_public_path__ + "static/media/fitnessGirlSignup.d25247be.png";